// AUTO-GENERATED GraphQL Builder for InvoiceRevision
import * as Builders from '../';
export class InvoiceRevisionBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  invoiceId(){ return this.add('invoiceId'); }
  revisionNo(){ return this.add('revisionNo'); }
  totalAmount(){ return this.add('totalAmount'); }
  reason(){ return this.add('reason'); }
  issuedDate(){ return this.add('issuedDate'); }
  depositAmount(){ return this.add('depositAmount'); }
  dueAmount(){ return this.add('dueAmount'); }
  protectionFee(){ return this.add('protectionFee'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  invoice(b?:(q:Builders.InvoiceBuilder)=>void){
    if(this.depth>=5||this.v.has('invoice'))return this;
    this.v.add('invoice');
    const n=new Builders.InvoiceBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoice { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  invoiceLineList(b?:(q:Builders.InvoiceLineBuilder)=>void){
    if(this.depth>=5||this.v.has('invoiceLineList'))return this;
    this.v.add('invoiceLineList');
    const n=new Builders.InvoiceLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceLineList { ${inner} }`);
    return this;
  }

  reverseInvoiceLine(b?:(q:Builders.InvoiceLineBuilder)=>void){
    const n=new Builders.InvoiceLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceLineList { ${inner} }`);
    return this;
  }
}
